export default __webpack_public_path__ + "static/media/tn-plan-avanzado.330b95f2.svg";